// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"kC","logoWrapper":"kD"};